import axios from '../Axios/Default';
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const DoLogin = (payload) => {
  const promise = axios.post("/login", payload, config);
  return promise;
};

export const checkUser = (hash) => {
  const promise = axios.get("/user/check/"+hash , [], config);
  return promise;
};


export const DoChangePassword = (payload) => {
  const promise = axios.post("/change-password", payload, config);
  return promise;
};


export const DoRefreshToken = (payload) => {
  const access_token = localStorage.getItem("access_token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
  const promise = axios.post("/refresh-token", payload, config);
  return promise;
};


export const DoSendOTP = (payload) => {
  const promise = axios.post("/forget-password/send-otp", payload, config);
  return promise;
};


export const DoVerificationOTP = (payload) => {
  const promise = axios.post("/forget-password/verify-otp", payload, config);
  return promise;
};


export const DoResetPassword = (payload) => {
  const promise = axios.post("/forget-password/reset-password", payload, config);
  return promise;
};